import {
    BrowserRouter as Router,
    Route,
    Routes,
    useLocation,
} from "react-router-dom";
import { Component, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Login from "./views/login/login";
import Home from "./views/home/home";
import Account from "./views/account/account";
import ResetPassword from "./views/reset_password/reset_password";
import EditPassword from "./views/account/edit_password";
import Register from "./views/register/register";
import RegisterStep2 from "./views/register/step2";
import RegisterStep3 from "./views/register/step3";
import RegisterStep4 from "./views/register/step4";
import RegisterStep5 from "./views/register/step5";
import User from "./views/user/user";
import Usager from "./views/user/usager";
import Ship from "./views/ship/ship";
import Ticket from "./views/ticket/ticket";
import AddTicket from "./views/ticket/add";
import ShowTicket from "./views/ticket/show";
import NotFound from "./views/not_found/NotFound";
import Terminal from "./views/terminal/terminals";
import Transactions from "./views/transactions/transactions";
import Procedures from "./views/procedures/procedures";
import UpdateNote from "./views/update_note/update_note";
import StartDistribution from "./views/remote_operations/start_distribution";
import StopDistribution from "./views/remote_operations/stop_distribution";
import ReserveConnector from "./views/remote_operations/reserve_connector";
import CancelReservattion from "./views/remote_operations/cancel_reservation";
import RestartTerminal from "./views/remote_operations/restart_terminal";
import AcceptCGU from "./views/account/accept_cgu";
/*import Tariff from "views/tariff/tariff";*/
import BoaterProcess from "./views/boater_process/boaterProcess";
import BoaterProcessStep1 from "./views/boater_process/boaterProcessStep1";
import BoaterProcessStep2 from "./views/boater_process/boaterProcessStep2";
import BoaterProcessChargingControl from "./views/boater_process/BoaterProcessChargingControl";
import BoaterProcessPayment from "./views/boater_process/boaterProcessPayment";
import BoaterTransaction from "./views/boater_process/boaterTransaction";

class RoutesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsedMenu: false,
            roles: [],
        };
    }

    handleOnRolesLoad = (roles) => {
        this.setState({ roles: roles });
    };

    render() {
        return (
            <Router>
                <AnimatePresence>
                    <Routes key="routes">
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/login"
                            element={
                                <Login onRolesLoad={this.handleOnRolesLoad} />
                            }
                        />
                        <Route
                            path="/account/accept_cgu"
                            element={<AcceptCGU />}
                        />
                        <Route
                            path="/account/activate/:token"
                            element={<ResetPassword />}
                        />
                        <Route path="/account" element={<Account />} />
                        <Route
                            path="/password/edit"
                            element={<EditPassword />}
                        />
                        <Route
                            path="/password/reset/:token"
                            element={<ResetPassword />}
                        />
                        <Route
                            path="/password/reset"
                            element={<ResetPassword />}
                        />
                        <Route path="/register/step1" element={<Register />} />
                        <Route
                            path="/register/step2"
                            element={<RegisterStep2 />}
                        />
                        <Route
                            path="/register/step3"
                            element={<RegisterStep3 />}
                        />
                        <Route
                            path="/register/step4"
                            element={<RegisterStep4 />}
                        />
                        <Route
                            path="/register/step5"
                            element={<RegisterStep5 />}
                        />
                        <Route path="/register" element={<Register />} />
                        <Route
                            path="/boater/step1"
                            element={<BoaterProcessStep1 />}
                        />
                        <Route
                            path="/boater/step1-2"
                            element={
                                <BoaterProcessChargingControl chargeAction="connect" />
                            }
                        />
                        <Route
                            path="/boater/step2"
                            element={<BoaterProcessStep2 />}
                        />
                        <Route
                            path="/boater/payment"
                            element={<BoaterProcessPayment />}
                        />
                        <Route
                            path="/boater/step4"
                            element={
                                <BoaterProcessChargingControl chargeAction="start" />
                            }
                        />
                        <Route
                            path="/boater/transaction/:energy/:transaction_id"
                            element={<BoaterTransaction />}
                        />
                        <Route
                            path="/boater/stop-charge"
                            element={
                                <BoaterProcessChargingControl chargeAction="stop" />
                            }
                        />
                        <Route path="/boater" element={<BoaterProcess />} />
                        <Route path="/user" element={<User />} />
                        <Route path="/usager" element={<Usager />} />
                        <Route path="/ship/:id" element={<Ship />} />
                        <Route path="/ship" element={<Ship />} />
                        <Route path="/ticket/new" element={<AddTicket />} />
                        <Route path="/ticket/:id" element={<ShowTicket />} />
                        <Route path="/ticket" element={<Ticket />} />
                        <Route path="/terminal" element={<Terminal />} />
                        <Route
                            path="/transaction/terminal/:cpo_id"
                            element={<Transactions />}
                        />
                        <Route
                            path="/transaction/boat/:ship_id/:ship_name"
                            element={<Transactions />}
                        />
                        <Route path="/transaction" element={<Transactions />} />
                        <Route path="/procedures" element={<Procedures />} />
                        <Route path="/update_note" element={<UpdateNote />} />
                        <Route
                            path="/operation/start_distribution"
                            element={<StartDistribution />}
                        />
                        <Route
                            path="/operation/stop_distribution"
                            element={<StopDistribution />}
                        />
                        <Route
                            path="/operation/reserve_connector"
                            element={<ReserveConnector />}
                        />
                        <Route
                            path="/operation/cancel_reservation"
                            element={<CancelReservattion />}
                        />
                        <Route
                            path="/operation/restart_terminal"
                            element={<RestartTerminal />}
                        />
                        {/* <Route path="/tariff" element={<Tariff />} /> */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    <ScrollTopFix key="scroll-top-fix" />
                </AnimatePresence>
            </Router>
        );
    }
}

export default RoutesComponent;

/**
 * REACT ROUTER DOM FIX
 * WHY ? React router Dom keeps scroll position on page change
 * Check if no anchor is passed to URL and scroll to top
 */
const ScrollTopFix = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        !hash &&
            setTimeout(
                () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                100,
            );
    }, [pathname, hash]);

    return <></>;
};
